@use "../../../globals/settings";
@use "../../../globals/bcp";
@use "../../../globals/libs/hy.core.css/layout/page-row";
@use "../../../globals/bcp-2022/objects/lists";

$self: ".o-footer";

.o-footer {
  .l-page-row {
    @include page-row.page-row;
  }

  #{$self}__top {
    display: grid;
    grid-template-rows: auto;
    grid-gap: bcp.size(32);
    padding-top: bcp.size(48);
    padding-bottom: bcp.size(24);

    @include bcp.respond-gte(tablet) {
      grid-template-rows: auto auto;
      grid-template-areas:
        "claim share"
        "language language"
        "links links";
      padding-top: bcp.size(56);
      padding-bottom: bcp.size(56);
    }

    #{$self}__links {
      @include lists.list("h");
      @include lists.set-space("h", bcp.size(16));
      justify-self: auto;

      @include bcp.respond-gte(tablet) {
        grid-area: links;

        @include lists.set-space("v", bcp.size(24));
      }

      @include bcp.respond(mobile) {
        @include lists.set-direction("v");
      }

      ::slotted(li) {
        @include bcp.set-css-var(link, color, settings.$text-color);
        @include bcp.set-css-var(link, text-decoration, none);
        list-style: none;
        margin-bottom: 0 !important; // shadow DOM + no global reset for li
      }
    }
  }

  #{$self}__claim {
    font-size: bcp.getFontSize("xl");

    @include bcp.respond-gte(tablet) {
      margin-top: bcp.size(8);
      grid-area: claim;
    }
  }

  #{$self}__share {
    display: inline-flex;
    gap: bcp.size(16);
    margin-left: bcp.size(-12);

    @include bcp.respond-gte(tablet) {
      grid-area: share;
      justify-self: right;
      margin-right: bcp.size(-12);
    }
  }

  #{$self}__bottom {
    padding-top: bcp.size(24);
    padding-bottom: bcp.size(32);
    position: relative;

    @include bcp.respond-gte(tablet) {
      display: flex;
      flex-wrap: wrap-reverse;
      padding-right: bcp.size(32);
      padding-bottom: bcp.size(8);
    }

    #{$self}__links {
      @include lists.list("h");

      @include lists.set-space("h", bcp.size(16));

      @include bcp.respond-gte(tablet) {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        order: 2;
        margin-bottom: bcp.size(24);

        @include lists.set-space("v", bcp.size(24));
        @include lists.set-space("h", bcp.size(8));
      }

      @include bcp.respond(mobile) {
        @include lists.set-direction("v");
      }

      ::slotted(li) {
        list-style: none;
        margin-bottom: 0 !important; // shadow DOM + no global reset for li

        @include bcp.set-css-var(link, color, settings.$text-color);

        @include bcp.set-css-var(link, text-decoration, none);
        font-size: bcp.getFontSize(
          "s"
        ) !important; // shadow DOM + no global reset for li

        @include bcp.set-css-var(button, font-size, bcp.getFontSize("s"));
      }
    }
  }

  #{$self}__copyright {
    font-size: bcp.getFontSize("s");

    @include bcp.respond-gte(tablet) {
      margin-right: bcp.size(24);
      margin-bottom: bcp.size(24);
      order: 1;
    }

    @include bcp.respond(mobile) {
      margin-top: bcp.size(16);
    }
  }

  #{$self}__back-to-top {
    position: absolute;
    top: bcp.size(-4);
    right: bcp.size(-12);
  }
}
